var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9V7C5.25 5.48122 6.48122 4.25 8 4.25H16C17.5188 4.25 18.75 5.48122 18.75 7V9H20C20.5523 9 21 9.44772 21 10V11C21.5523 11 22 11.4477 22 12V16C22 16.5523 21.5523 17 21 17V18C21 18.5523 20.5523 19 20 19H15.0704C14.4017 19 13.7772 18.6658 13.4063 18.1094L12.8321 17.2481C12.4362 16.6543 11.5638 16.6543 11.1679 17.2481L10.5937 18.1094C10.2228 18.6658 9.59834 19 8.92963 19H4C3.44772 19 3 18.5523 3 18V17C2.44772 17 2 16.5523 2 16V12C2 11.4477 2.44772 11 3 11V10C3 9.44772 3.44772 9 4 9H5.25ZM6.75 7V9H17.25V7C17.25 6.30964 16.6904 5.75 16 5.75H8C7.30964 5.75 6.75 6.30964 6.75 7ZM19 14C19 12.8954 18.1046 12 17 12C15.8954 12 15 12.8954 15 14C15 15.1046 15.8954 16 17 16C18.1046 16 19 15.1046 19 14ZM7 16C8.10457 16 9 15.1046 9 14C9 12.8954 8.10457 12 7 12C5.89543 12 5 12.8954 5 14C5 15.1046 5.89543 16 7 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/vr.7706e389ca1636f4d540587b90872f40.svg";
export { ForwardRef as ReactComponent };